export default __webpack_public_path__ + "static/media/Helm of Vengeful Zeal.bca02a0b.jpg";